<template>
  <!-- 팝업: -->
  <section
    :class="['popup', popClass]"
    v-if="visible"
    role="dialog"
    aria-modal="true"
    :aria-labelledby="titleId"
    tabindex="-1"
    @keyup.esc="$emit('close')"
    ref="modal"
  >
    <div :class="['popup__container', popSizeClass]">
      <div class="popup__tit" :id="titleId">
        {{ pop_tit }}
      </div>
      <button type="button" class="popup__close" @click="$emit('close')">
        <i class="svg_icon icon_del" aria-hidden="true"></i>팝업 닫기
      </button>
      <div class="popup__content">
        <slot name="pop_content"></slot>
      </div>
      <div class="popup__btns" v-if="$slots.pop_buttons">
        <slot name="pop_buttons"></slot>
      </div>
    </div>
    <i class="bg_close" @click="$emit('close')" aria-hidden="true"></i>
  </section>
</template>
<script>
import { nextTick, ref, watch } from "vue";
export default {
  name: "Modal",
  props: {
    pop_tit: { type: String, default: "팝업 제목" },
    popSizeClass: { type: String, default: "l" },
    popClass: { type: String },
    visible: { type: Boolean, default: false },
  },
  setup(props) {
    const modal = ref(null);
    const titleId = `modal-title-${Math.random().toString(36).slice(2, 9)}`;

    watch(
      () => props.visible,
      async (val) => {
        if (val) {
          await nextTick();
          modal.value?.focus(); // 모달 컨테이너로 포커스 이동
        }
      }
    );

    return { modal, titleId };
  },
};
</script>